<template>
<div class="categories-page">
  <div class="static-container">
    <CategoryNestedTiles v-if="!isWideScreen" :categories="childCategories" />
    <template v-else>
      <router-link v-if="thisCategory !== 'root'"
                   :to="{ name: 'catalog', params: { categoryId: thisCategory.short_id, categorySlug: thisCategory.slug } }"
                   class="categories-page__all-products-link"
      >
        Все товары категории «{{ thisCategory.name }}»
      </router-link>
      <CategoryTiles :categories="childCategories" />
    </template>
  </div>
</div>
</template>

<script>
import findCategoryInTree from '@/helpers/findCategoryInTree';

export default {
  components: {
    CategoryNestedTiles: () => import('@/components/CategoryNestedTiles'),
    CategoryTiles: () => import('@/components/CategoryTiles'),
  },
  props: {
    categoryId: {
      type: String,
      required: false
    },
  },
  computed: {
    /**
     * @returns {'root' | object}
     */
    thisCategory() {
      if (!this.categoryId) {
        return 'root';
      }
      return findCategoryInTree(this.$store.state.catalog.visibleCategoriesTree, this.categoryId);
    },
    childCategories() {
      const c = this.thisCategory;
      if (c === 'root') {
        return this.$store.state.catalog.visibleCategoriesTree;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (c.children.length === 0) {
          console.error('Attempted to show categories page for a category with no child categories');
          // this.$router.replace({ name: 'catalog', params: { categoryId: c.short_id, categorySlug: c.slug } });
        }
      }
      return c.children;
    },
    isWideScreen() {
      return this.$store.getters['ui/isBreakpointActive']('sm');
    }
  }
}
</script>

<style lang="less">
.categories-page {
  @apply p-4;
  &__all-products-link {
    @apply block text-center mt-4 mb-8 underline;
  }
}
</style>
